import api from './api';

const userSkillsService = {
  // Get all skills with filtering
  getAll: async (params = {}) => {
    const response = await api.get('/user-skills', { params });
    return response.data;
  },

  // Get skill by ID
  getById: async (id) => {
    const response = await api.get(`/user-skills/${id}`);
    return response.data;
  },

  // Create new skill
  create: async (skillData) => {
    const response = await api.post('/user-skills', skillData);
    return response.data;
  },

  // Update skill
  update: async (id, skillData) => {
    const response = await api.put(`/user-skills/${id}`, skillData);
    return response.data;
  },

  // Delete skill
  delete: async (id) => {
    const response = await api.delete(`/user-skills/${id}`);
    return response.data;
  },

  // Get skills by user
  getByUser: async (userId) => {
    const response = await api.get(`/user-skills/user/${userId}`);
    return response.data;
  },

  // Search by skill
  searchBySkill: async (params) => {
    const response = await api.get('/user-skills/search', { params });
    return response.data;
  },

  // Get skill statistics
  getStatistics: async (params = {}) => {
    const response = await api.get('/user-skills/statistics', { params });
    return response.data;
  },

  // Helper: Get proficiency color
  getProficiencyColor: (level) => {
    const colors = {
      'Beginner': 'badge-info',
      'Intermediate': 'badge-warning',
      'Advanced': 'badge-success',
      'Expert': 'badge-primary'
    };
    return colors[level] || 'badge-secondary';
  },

  // Helper: Format years experience
  formatYearsExperience: (years) => {
    if (!years) return 'N/A';
    return years === 1 ? '1 year' : `${years} years`;
  }
};

export default userSkillsService;

// ---